import { Injectable } from '@angular/core';
import { NotificationBaseApi } from './notification-base-api';

@Injectable({providedIn: 'root'})
export class OrgNotificationApi extends NotificationBaseApi {
  protected apiUrl = '/org/api/v1';
}
